module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image1-b7b6dcee25ac02ec823a1ef06644eee0.png";